import { memo } from 'react';

import { CURRENCIES } from '@bitstopco/bitstop-theme/constants';
import { formatCurrency } from '@bitstopco/bitstop-theme/helpers';

import { Stack, Typography } from '@mui/material';

import theme from '@/helpers/theme';

import type { TransactionsSale } from '@/types';

interface TransactionsSaleSentProps {
  value: string;
  data: TransactionsSale;
}

const TransactionsSaleSent = ({ data, value }: TransactionsSaleSentProps) => {
  const symbol = data.coin?.ticker ?? data.asset?.symbol ?? 'BTC';
  const crypto = data.crypto_amount;
  const currencySymbol = CURRENCIES[data?.currency_code as keyof typeof CURRENCIES] || '$';

  return (
    <Stack>
      {value && (
        <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }} textAlign="right">
          {crypto}{' '}
          <Typography variant="body2" component="span" fontWeight="bold">
            {symbol}
          </Typography>
        </Typography>
      )}

      <Typography variant="body2" color={theme.palette.text.secondary} textAlign="right">
        {value ? formatCurrency(+(value || 0), currencySymbol) : '-'}
      </Typography>
    </Stack>
  );
};

export default memo(TransactionsSaleSent);
